import { Dispatch, SetStateAction } from "react"
import { Edge, Node } from "reactflow"

export type UINode = {
  id: string
  nodeType: string
  rowIndex?: number
}

export type UIEntity = {
  isNew?: boolean
  isUpdated?: boolean
}

export type UIRowLabel = UIEntity & {
  id: string
  text?: string
  rowIndex: number
}

export type UIMatrixLabelsLabel = UIEntity & {
  id: string
  text?: string
  sheetId: number
}

export type UICell = UIEntity & {
  id: string
  name?: string
  value?: string
  operator?: string
  valueType?: number | null
  rowIndex: number
  columnIndex: number
  nodes?: UINode[]
  sheetId: string
}

export type UIColumn = {
  id: string
  text?: string
  width?: number
  columnIndex: number
  sheetId: string
}

export type UIEdge = UIEntity & {
  id: string
  appearanceType: number
  sourceSheetId: string | null
  targetSheetId: string | null
  sourceRowIndex: number | null
  targetRowIndex: number | null
  sourceLogicId: string | null
  targetLogicId: string | null
  sourceEntityType: UISheetType | undefined
  targetEntityType: UISheetType | undefined
}

export type UISheet = UIEntity & {
  id: string
  name?: string
  cells: UICell[]
  columns: UIColumn[]
  rowLabels?: UIRowLabel[]
  columnLabelsLabel?: string
  rowLabelsLabel?: string
  x: number
  y: number
  isDataSheet?: boolean
  edgeHandles: UINode[]
  enityType?: UISheetType
  width?: number | null
  height?: number | null
}

export enum UILogicType {
  "AND" = "018f6f25-cf1e-73f8-aafb-b8c999f5cd54",
  "OR" = "018f6f25-cf21-7c4c-aeb6-4e623d007f28",
}

export enum UISheetType {
  SHEET = "sheet",
  MATRIX = "matrix",
  CONDITION = "condition",
}

export type UILogic = UIEntity & {
  id: string
  name: string
  logicType: string
  edgeHandles: UINode[]
}

export type UIFlowChartChoiceBlock = UIEntity & {
  id: string
  text: string
}

export enum EditorMode {
  "INLINE" = "1",
  "FORM" = "2",
}

export type SheetField = {
  id: string
  name?: string
  alias?: string
  type?: number | null
  isNew?: boolean
  isEdited?: boolean
  rowIndex: number
}

export type PastedCellContent = {
  text?: string
  rowIndex: number
  columnIndex: number
}

export type SetNodesState = Dispatch<
  SetStateAction<
    Node<UISheet | UILogic | UIFlowChartChoiceBlock, string | undefined>[]
  >
>

export type SetEdgesState = Dispatch<React.SetStateAction<Edge<any>[]>>

export type CanvasNodes = Node<
  UISheet | UILogic | UIFlowChartChoiceBlock,
  string | undefined
>[]

export type CanvasEdges = Edge<any>[]

export type AutogenResultType = {
  importedSheets: Node<UISheet>[]
  importedEdges: Edge<UIEdge>[]
  importedLogics: Node<UILogic>[]
}

export type UserProfile = {
  picture?: string
  firstName?: string
  lastName?: string
}
